import { useTranslation } from 'react-i18next';

import Collapse from 'components/collapse/Collapse';
import { MESSAGES_SENT_TO_GUESTS_TEMPLATE_ROWS } from '../SystemTemplatesTab.constants';
import SystemTemplatesTable from './common/SystemTemplatesTable';
import useVisibleSystemTemplateRows from './common/useVisibleSystemTemplateRows';

const MessagesSentToGuestsSection = () => {
  const { t } = useTranslation();
  const { rows, isLoading } = useVisibleSystemTemplateRows(
    MESSAGES_SENT_TO_GUESTS_TEMPLATE_ROWS,
  );

  return (
    <Collapse
      data-testid="messages-sent-to-guests"
      defaultExpanded
      label={t('pageAutomations.systemTemplates.sections.messagesSentToGuests')}
      variant="card"
    >
      <SystemTemplatesTable
        data-testid="messages-sent-to-guests-table"
        data={rows}
        isLoading={isLoading}
      />
    </Collapse>
  );
};

export default MessagesSentToGuestsSection;
